 
namespace TabAurous.Retail {
    import fld = POSReturnItemsBOMRow.Fields;
    @Serenity.Decorators.registerClass()
   
    export class POSReturnItemsBOMEditor extends _Ext.BOMGridEditor<POSReturnItemsBOMRow> { 
        protected getDialogType() { return POSReturnItemsBOMDialog; }
        protected getLocalTextPrefix() { return POSReturnItemsBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));            
        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        } 
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

    }
}